import "../pages.scss"
import { ListasCabState } from '../../context/listascab/ListasCabState';
import Datatable from "./listasCabTable/Datatable"

const ListasCabPage = () => {
  return (
    <>
      <ListasCabState>
        <Datatable />
      </ListasCabState>

    </>
  )
}

export default ListasCabPage